import { Alert, Button } from "@mui/material"
import css from './ConfirmButton.module.css'

const ConfirmButton = ({ isError, isUploading, isComplete, onClick })=> (
  <div className={css.confirm}>
    {isError && (
      <Alert icon={<i className='material-icons'>error</i>} severity="error">
        No se han guardado los documentos. Por favor inténtalo de nuevo.
      </Alert>
    )}
    <Button
      color="primary"
      variant='contained'
      startIcon={<i className='material-icons'>{isComplete ? 'check' : 'save'}</i>}
      disabled={isUploading || isComplete}
      onClick={onClick}
    >
      {isComplete && 'Documentos guardados'}
      {!isComplete && (isUploading ? 'Guardando...' : 'Confirmar y guardar')}
    </Button> 
  </div>
)

export default ConfirmButton